<template>
  <Modal title="固定排课" v-model="visible" width="950">
    <Form class="form scheduling">
      <Row class="module">
        <Col :span="3" :offset="1">
          <h3>学生信息</h3>
        </Col>
        <Col :span="18">
          <Row>
            <Col :span="8" class="row">
              <label class="field">学生姓名：</label>
              <label>{{ user.nickname }}</label>
            </Col>
            <Col :span="10" class="row">
              <label class="field">学生手机号：</label>
              <label>{{ user.mobile }}</label>
            </Col>
            <br/>
            <Col :span="8" class="row">
              <label class="field">常规课次数：</label>
              <label>{{ bookUserPackage.routineNum }}</label>
            </Col>
            <Col :span="8" class="row">
              <label class="field">常规课已选次数：</label>
              <label>{{ bookUserPackage.routineSelectNum }}</label>
            </Col>
            <Col :span="8" class="row">
              <label class="field">常规课已上次数：</label>
              <label>{{ bookUserPackage.routineEndNum }}</label>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row class="module">
        <Col :span="3" :offset="1">
          <h3>历史课程</h3>
        </Col>
        <Col :span="20">
          <Table class="compact" size="small"
            :columns="bookLessonOpenedColumn" :data="bookLessonOpenedList"></Table>
        </Col>
      </Row>
      <Row class="module">
        <Col :span="3" :offset="1">
          <h3>上课时间</h3>
        </Col>
        <Col :span="20">
          <Checkbox-group v-model="scheduleIndexList">
            <Row v-for="(item, index) in courseScheduleListData" :key="index" :gutter="8" style="margin-bottom:5px">
              <Col :span="9">
                <Checkbox :label="index" disabled><i></i></Checkbox>
                <span>{{ $moment(item.day, 'X').format('YYYY-MM-DD') }} {{ $constant.weekZh[item.week] }} {{ $moment.unix(item.startTime).utc().format('HH:mm') }} - {{ $moment.unix(item.endTime).utc().format('HH:mm') }}</span>
              </Col>
              <Col :span="5">
                <span>{{item.firstName}} {{item.lastName}}</span>
              </Col>
              <Col :span="5">
                <span v-if="item.lsnSelStatus === 6 || item.lsnSelStatus === 13">{{ item.lsnSelStatus === 13 ? '老师离职' : '老师请假' }}</span>
                <Select v-else size="small" v-model="item.levelId" @on-change="onBookMaterialLevelChange(item, index)" filterable transfer>
                  <Option v-for="levelItem in bookMaterialLevelList"
                    :value="levelItem.id" :key="levelItem.id">{{ levelItem.title }}</Option>
                </Select>
              </Col>
              <Col :span="6">
                <span v-if="item.lsnSelStatus === 6 || item.lsnSelStatus === 13">不占课件顺序</span>
                <Select v-else size="small" v-model="item.lessonId" filterable transfer>
                  <Option  v-for="lessonItem in bookMaterialLessonsList[index]"
                    :value="lessonItem.id" :key="lessonItem.id">{{ lessonItem.titleEn }}</Option>
                </Select>
              </Col>
              <Col :span="4">
                <Select v-model="item.schoolId">
                  <Option v-for="item in $constant.schoolEnums"
                          :value="item.code" :key="item.code">{{ item.text }}</Option>
                </Select>
              </Col>
            </Row>
        </Checkbox-group>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingAdd" @click="add">保存</Button>
    </div>
  </Modal>
</template>
<style>
  .scheduling .module {
    margin-bottom: 10px;
  }
  .scheduling .module .field {
    font-weight: bold;
  }
  .scheduling .module .row {
    margin-bottom: 8px;
  }
  .scheduling .ivu-table td {
    height: 28px;
  }
</style>
<script>
  export default {
    name: 'CourseSchedulingModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      uid: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      let $constant = this.$constant
      let $moment = this.$moment
      return {
        visible: this.value,
        loadingAdd: false,
        bookLessonOpenedList: [],
        bookLessonOpenedColumn: [
          {
            title: '日期',
            align: 'center',
            width: 120,
            render: (h, params) => {
              let lsnBeginTime = params.row.lsnBeginTime
              let week = params.row.week
              return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD') + ' ' + $constant.weekZh[week])
            }
          },
          {
            title: '时间',
            align: 'center',
            width: 100,
            render: (h, params) => {
              let lsnBeginTime = params.row.lsnBeginTime
              let lsnEndTime = params.row.lsnEndTime
              return h('span', $moment(lsnBeginTime, 'X').format('HH:mm') + ' - ' + $moment(lsnEndTime, 'X').format('HH:mm'))
            }
          },
          {
            title: '老师',
            align: 'center',
            width: 120,
            render: (h, params) => {
              if (params.row.tchFirstName || params.row.tchLastName) {
                return h('span', params.row.tchFirstName + ' ' + params.row.tchLastName)
              } else {
                return h('span', '')
              }
            }
          },
          {
            title: '状态',
            width: 85,
            align: 'center',
            render: (h, params) => {
              let lsnSelStatus = params.row.lsnSelStatus
              let statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '等级名称',
            width: 120,
            key: 'levelTitleEn'
          },
          {
            title: '课程名称',
            key: 'lessonTitle'
          }
        ],
        bookUserPackage: {},
        // tch: {},
        user: {},
        scheduleIndexList: [],
        bookMaterialLevelList: null,
        courseScheduleListData: [],
        bookMaterialLessonsList: [],
        bookMaterialLessonsListCache: []
      }
    },
    methods: {
      add () {
        let self = this
        self.loadingAdd = true
        let courseScheduleListDataTmp = JSON.parse(JSON.stringify(self.courseScheduleListData))
        let courseScheduleListData = []
        self.scheduleIndexList.forEach(element => {
          let courseSchedule = courseScheduleListDataTmp[element]
          delete courseSchedule.bookMaterialLessonsList
          courseScheduleListData.push(courseSchedule)
        })
        self.$http.post('/user/lesson/addCourseSchedule', {}, {
          transformRequest: [function (data, headers) {
            return JSON.stringify(courseScheduleListData)
          }],
          headers: {'Content-Type': 'application/json;charset=utf-8'},
        }).then(function (res) {
          self.loadingAdd = false
          if (res) {
            self.$Message.success('排课成功!')
            self.visible = false
            return
          }
        }).catch(function (e) {
          self.loadingAdd = false
        })
      },
      onLoad () {
        let self = this
        let loadMsg = this.$Message.loading('正在加载中...', 0)
        self.$http.get('/user/lesson/queryCourseSchedule', { params: {uid: self.uid} }).then(function (res) {
          loadMsg()
          if (!res || !res.data) {
            self.$emit('input', false)
            return
          }
          let data = res.data
          self.bookUserPackage = data.bookUserPackage
          self.bookLessonOpenedList = data.historyLesson
          // self.tch = data.tch
          self.user = data.user
          self.courseScheduleListData = data.courseSchedule
          let scheduleIndex = 0
          let scheduleIndexList = []
          self.courseScheduleListData.forEach(element => {
            self.bookMaterialLessonsList = data.bookMaterialLessonsList
            scheduleIndexList.push(scheduleIndex++)
            element.uid = self.user.id
            element.classType = '1'
          })
//          self.initBookMaterialLessonsList()
          self.scheduleIndexList = scheduleIndexList

          self.visible = true
        })
      },
      loadBookMaterialLevel () {
        let self = this
        if (self.bookMaterialLevelList) {
          return
        }
        self.$http.get('/bookMaterialLevel/listByCondition?status=1').then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.bookMaterialLevelList = res.data
        })
      },
//      initBookMaterialLessonsList () {
//        let self = this
//        let levelIds = []
//        self.courseScheduleListData.forEach(element => {
//          let isExist = false
//          levelIds.forEach(levelId => {
//            if (levelId === element.levelId) {
//              isExist = true
//            }
//          })
//          if (!isExist) {
//            levelIds.push(element.levelId)
//          }
//        })
//        self.courseScheduleListData.forEach(element => {
//          self.bookMaterialLessonsList.push(
//            self.getBookMaterialLessonsListByLevelId(element.levelId))
//        })
//      },
//      getBookMaterialLessonsListByLevelId (levelId) {
//        let self = this
//        let bookMaterialLessonsList
//        self.bookMaterialLessonsListCache.forEach(element => {
//          if (element[0].levelId === levelId) {
//            bookMaterialLessonsList = element
//            return
//          }
//        })
//        if (bookMaterialLessonsList) {
//          return bookMaterialLessonsList
//        }
//        var promise = new Promise((resolve, reject) => {
//          self.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + levelId).then(res => {
//            if (!res || !res.data) {
//              return
//            }
//            bookMaterialLessonsList = res.data
//            self.bookMaterialLessonsListCache.push(bookMaterialLessonsList)
//            resolve(bookMaterialLessonsList)
//          })
//        })
//        promise.then(value => {
//          bookMaterialLessonsList = value
//        })
//        return bookMaterialLessonsList
//      },
      onBookMaterialLevelChange (val, index) {
        let self = this
        if (val.levelId === '' || val.levelId === null || val.levelId === undefined) {
          return
        }
        this.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + val.levelId).then(res => {
          if (!res || !res.data) {
            return
          }
          val.lessonId = ''
          self.bookMaterialLessonsList.splice(index, 1, res.data)
          // self.onLoad()
        })
      }
    },
    watch: {
      value (val) {
        if (val === true) {
          this.onLoad()
          this.loadBookMaterialLevel()
        } else {
          this.$emit('on-close', val)
          this.scheduleIndexList = []
          this.bookMaterialLevelList = null
          this.courseScheduleListData = []
          this.bookMaterialLessonsList = []
          this.bookMaterialLessonsList = []
          this.bookMaterialLessonsListCache = []
          this.visible = val
        }
      },
      visible (val) {
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CourseSchedulingModal.vue?0e5f8ec2